<div class="betriebskontakte-page">
    <div class="list-title-row">
        <button *ngIf="showReturnButton" mat-icon-button color="accent" (click)="goBack()">
            <mat-icon>arrow_back</mat-icon>
        </button>
        <h3 class="list-title">Meine Betriebskontakte</h3>
        <button
            (click)="toggleSuche()"
            color="accent"
            mat-icon-button
            matTooltip="Kontakt hinzufügen"
        >
            <mat-icon>{{ zeigeSuche ? "close" : "add" }}</mat-icon>
        </button>
        <span class="spacer"></span>
    </div>

    <!-- Suchbereich -->
    <div style="margin-bottom: 24px">
        <kiene-betriebskontakte-erstellen-dialog
            [zeigeSuche]="zeigeSuche"
            (kontaktHinzugefuegt)="onKontaktHinzugefuegt()"
            (schliesseSuche)="onSchliesseSuche()"
        ></kiene-betriebskontakte-erstellen-dialog>
    </div>

    <!-- Ladeindikator -->
    <div *ngIf="ladeKontakte" style="text-align: center; margin: 48px 0">
        <mat-spinner></mat-spinner>
        <p style="margin-top: 16px">Lade Kontakte...</p>
    </div>

    <!-- Kontaktliste -->
    <div *ngIf="!ladeKontakte">
        <div *ngIf="kontakte.length === 0" style="text-align: center; margin: 48px 0; color: #666">
            <mat-icon style="font-size: 48px; height: 48px; width: 48px; margin-bottom: 16px">contacts</mat-icon>
            <h3>Noch keine Betriebskontakte</h3>
            <p>Fügen Sie Ihren ersten Kontakt über die Suche hinzu.</p>
        </div>

        <!-- Filter-Buttons -->
        <div class="filter-container">
            <button
                mat-button
                [class.active-filter]="selectedFilter === 'all'"
                (click)="setFilter('all')"
                class="filter-button"
            >
                Alle ({{ kontakte.length }})
            </button>
            <button
                mat-button
                [class.active-filter]="selectedFilter === 'landwirt'"
                (click)="setFilter('landwirt')"
                class="filter-button"
            >
                Landwirte ({{ getFilteredCount("landwirt") }})
            </button>
            <button
                mat-button
                [class.active-filter]="selectedFilter === 'haendler'"
                (click)="setFilter('haendler')"
                class="filter-button"
            >
                Händler ({{ getFilteredCount("haendler") }})
            </button>
            <!-- Schlachthof-Filter entfernt -->
        </div>

        <!-- Suchleiste -->
        <div class="search-container" style="margin: 16px 0">
            <mat-form-field appearance="outline" class="search-field">
                <mat-label>Kontakte durchsuchen...</mat-label>
                <input matInput [formControl]="searchControl" placeholder="Nach Name, VVVO oder Ort suchen..." />
                <span matSuffix class="search-suffix">
                    <button
                        *ngIf="searchControl.value"
                        mat-icon-button
                        (click)="searchControl.setValue('')"
                        aria-label="Suche löschen"
                    >
                        <mat-icon>close</mat-icon>
                    </button>
                    <mat-icon class="search-suffix-icon">search</mat-icon>
                </span>
            </mat-form-field>
        </div>

        <!-- Kontakte als Cards -->
        <div class="kontakte-grid">
            <kiene-betriebskontakt-card
                *ngFor="let kontakt of getFilteredKontakte()"
                [kontakt]="kontakt"
                [config]="{
                    showActions: true,
                    showMenu: true,
                    showFavorit: true,
                    showBadge: true,
                    compact: false,
                    showHinzufuegen: true,
                    istKontaktBereitsVorhanden: istKontaktBereitsVorhanden(kontakt),
                    canEdit: canEditKontakt(kontakt)
                }"
                (bearbeiten)="onBearbeiten($event)"
                (toggleFavorit)="onToggleFavorit($event)"
                (entfernen)="onEntfernen($event)"
                (sendMail)="onSendMail($event)"
                (callPhone)="onCallPhone($event)"
            >
            </kiene-betriebskontakt-card>
        </div>
    </div>
</div>
